import { Box } from '@mui/material'
import RenderComponent from 'components/RenderComponent'
import React from 'react'

export default function index({ className = "", name, data, ...other }) {
    return (
        <Box className={className}><RenderComponent name={name} data={data} {...other} /></Box>
    )
}
